import React from "react";

const LazyWPPreview = React.lazy(() => import("./WPPreview"));

export default LazyWPPreview;
